export default __webpack_public_path__ + "static/media/background_start.7191e1ca.jpg";